import React , { lazy } from "react";

import CommExample from "../modules/CommExample";

//CPM
const Cpds0010e01 = lazy(() => import( "modules/cp/ds/Cpds0010e01"))   ;
const Cpbr0010e01 = lazy(() => import( "modules/cp/br/Cpbr0010e01"))   ;
const Cpbr0020e01 = lazy(() => import( "modules/cp/br/Cpbr0020e01"))   ;
const Cpbr0030e01 = lazy(() => import( "modules/cp/br/Cpbr0030e01"))   ;
const Cpbr0050e01 = lazy(() => import( "modules/cp/br/Cpbr0050e01"))   ;
const Cpbr0070e01 = lazy(() => import( "modules/cp/br/Cpbr0070e01"))   ;
const Cpbr0080e01 = lazy(() => import( "modules/cp/br/Cpbr0080e01"))   ;
const Cpbr0090e01 = lazy(() => import( "modules/cp/br/Cpbr0090e01"))   ;
const Cpbr0100e01 = lazy(() => import( "modules/cp/br/Cpbr0100e01"))   ;
const Cpbr0110e01 = lazy(() => import( "modules/cp/br/Cpbr0110e01"))   ;

//CPRP
const Cpbr0060e01 = lazy(() => import( "modules/cp/br/Cpbr0060e01"))   ;

//보고서
const Cprp0010e01 = lazy(() => import( "modules/cp/rp/Cprp0010e01"))   ;
const Cprp0020e01 = lazy(() => import( "modules/cp/rp/Cprp0020e01"))   ;
const Cprp0030e01 = lazy(() => import( "modules/cp/rp/Cprp0030e01"))   ;

//케이블 제안서
const Cpca0010e01 = lazy(() => import( "modules/cp/ca/Cpca0010e01"))   ;
const Cpca0020e01 = lazy(() => import( "modules/cp/ca/Cpca0020e01"))   ;


//케이블 제안서 보고서
const Mdca0010e01 = lazy(() => import( "modules/md/ca/Mdca0010e01"))   ;
const Mdca0020e01 = lazy(() => import( "modules/md/ca/Mdca0020e01"))   ;

//관리 - CRM
const Cmcd0010e01 = lazy(() => import( "modules/cm/cd/Cmcd0010e01"))   ;



lazy(() => import( "modules/cp/br/Cpbr0020e02"))   ;
lazy(() => import( "modules/cp/br/Cpbr0020e03"))   ;
lazy(() => import( "modules/cp/br/Cpbr0040e01"))   ;
lazy(() => import( "modules/cp/br/Cpbr0040e02"))   ;
lazy(() => import( "modules/cp/br/Cpbr0040e03"))   ;

lazy(() => import( "modules/cp/br/Cpbr0060e02"))   ;
lazy(() => import( "modules/cp/br/Cpbr0060e03"))   ;
lazy(() => import( "modules/cp/br/Cpbr0060e05"))   ;

lazy(() => import( "modules/cp/br/Cpbr0060p01"))   ;
lazy(() => import( "modules/cp/br/Cpbr0060p02"))   ;

lazy(() => import( "modules/cp/br/Cpbr0070e01"))   ;
lazy(() => import( "modules/cp/br/Cpbr0080e01"))   ;

lazy(() => import( "modules/cp/br/Cpbr0090e01")) ;
lazy(() => import( "modules/cp/br/Cpbr0100e01")) ;
lazy(() => import( "modules/cp/br/Cpbr0110e01")) ;


lazy(() => import( "modules/md/ca/Mdca0010e02"))   ;
lazy(() => import( "modules/md/ca/Mdca0010e03"))   ;
lazy(() => import( "modules/md/ca/Mdca0010e04"))   ;


lazy(() => import( "modules/cm/cd/Cmcd0010e01"))   ;

lazy(() => import( "modules/cp/ca/Cpca0020e02"))   ;
lazy(() => import( "modules/cp/ca/Cpca0020e03"))   ;
lazy(() => import( "modules/cp/ca/Cpca0020e04"))   ;
lazy(() => import( "modules/cp/ca/Cpca0020p01"))   ;



const publicRoutes = [
  { path: `/`, component: <Cpbr0050e01 /> },
  // ds
  { path: `/cpds0010e01`, component: <Cpds0010e01 /> },
  // br
  { path: `/cpbr0010e01`, component: <Cpbr0010e01 /> },
  { path: `/cpbr0020e01`, component: <Cpbr0020e01 /> },
  { path: `/cpbr0030e01`, component: <Cpbr0030e01 /> },
  { path: `/cpbr0050e01`, component: <Cpbr0050e01 /> },
  { path: `/cpbr0060e01`, component: <Cpbr0060e01 /> },
  { path: `/cpbr0070e01`, component: <Cpbr0070e01 />, fullscreen : "Y" },
  { path: `/cpbr0080e01`, component: <Cpbr0080e01 />, fullscreen : "Y" },
  { path: `/cpbr0090e01`, component: <Cpbr0090e01 /> },
  { path: `/cpbr0100e01`, component: <Cpbr0100e01 /> },
  { path: `/cpbr0110e01`, component: <Cpbr0110e01 /> },
   
   //케이블
  { path: `/cpca0010e01`, component: <Cpca0010e01 /> },
  { path: `/cpca0020e01`, component: <Cpca0020e01 /> },
  
  // rp
  { path: `/cprp0010e01`, component: <Cprp0010e01 /> },
  { path: `/cprp0020e01`, component: <Cprp0020e01 /> },
  { path: `/cprp0030e01`, component: <Cprp0030e01 /> },
  
  // md
  { path: `/mdca0010e01`, component: <Mdca0010e01 />, fullscreen : "Y" },
  { path: `/mdca0020e01`, component: <Mdca0020e01 />, fullscreen : "Y" },

 // example
  { path: `/commExample`, component: <CommExample /> },

  //시뮬레이션(포털화면)
  { path: `/front/upSimulation`, component: <Cpbr0110e01 {...{ fullscreen:true}} /> ,  fullscreen : "Y"},
  
  
  // cm/cd
    { path: `/cmcd0010e01`, component: <Cmcd0010e01 /> },
    
];

export { publicRoutes };
